import feathers from '@feathersjs/feathers';
import rest from '@feathersjs/rest-client';
import axios from 'axios';

let restApp = null;

export const getRestClient = () => {
  if (!restApp) {
    const restClient = rest(window.__RUNTIME_CONFIG__.REACT_APP_API_URL);

    restApp = feathers().configure(restClient.axios(axios));

    restApp.hooks({
      before: {
        all: [
          (context) => {
            const token = window.localStorage.getItem('auth');
            context.params.headers = {
              ...(context.params.headers || {}),
              Authorization: token ? `Bearer ${token}` : '',
              'Content-Type': 'multipart/form-data',
            };
            return context;
          },
        ],
      },
    });
  }
  return restApp;
};
